import { render, staticRenderFns } from "./DichVuLuuTruList.vue?vue&type=template&id=0ea4e84b"
import script from "./DichVuLuuTruList.vue?vue&type=script&lang=js"
export * from "./DichVuLuuTruList.vue?vue&type=script&lang=js"
import style0 from "./DichVuLuuTruList.vue?vue&type=style&index=0&id=0ea4e84b&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports